import { useEffect } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import useInterfaceSoundCore from "@/shared/hooks/useInterfaceSoundCore";
import { Soundtrack } from "@/shared/sounds";
import Loader from "@/shared/ui/Loader";
import { userSelector } from "@/domains/account/slice";
import { setPlayerInfo } from "@/domains/player/slice";
import useAccountSettings from "@/domains/account/hooks/useAccountSettings";
import useGetCharacters from "@/domains/account/hooks/useGetCharacters";
import useGetUser from "@/domains/account/hooks/useGetUser";
import useShowAccount from "@/domains/account/hooks/useShowAccount";
import useGameSettings from "@/domains/settings/hooks/useGameSettings";
import AccountSidebarContainer from "@/domains/account/containers/AccountSidebarContainer.tsx";
import AccountSlotsContainer from "@/domains/account/containers/AccountSlotsContainer";
import Account from "@/domains/account/components/Account.tsx";
import useChatSettings from "@/domains/settings/chat/hooks/useChatSettings";
import useControlSettings from "@/domains/settings/control/hooks/useControlSettings";

function AccountContainer() {
  const dispatch = useAppDispatch();
  const { getGameSettings } = useGameSettings();
  const { getControlSettings } = useControlSettings();
  const { getChatSettings } = useChatSettings();
  const { getAccountSettings } = useAccountSettings();
  const { isShow } = useShowAccount();
  const { getUser } = useGetUser();
  const { getCharacters } = useGetCharacters();
  const user = useAppSelector(userSelector);
  const { play, stop } = useInterfaceSoundCore(Soundtrack.AccountBackground);

  useEffect(() => {
    play();

    return () => {
      stop();
    };
  }, []);

  useEffect(() => {
    (async () => {
      if (isShow) {
        if (!user) {
          await getUser();
        }
        await getCharacters();
      }
    })();
  }, [getCharacters, getUser, isShow, user]);

  useEffect(() => {
    if (isShow) {
      getGameSettings();
      getChatSettings();
      getControlSettings();
      getAccountSettings();
    }

    return () => {
      dispatch(setPlayerInfo(null));
    };
  }, [isShow, getGameSettings, getChatSettings, getControlSettings, getAccountSettings, dispatch]);

  if (!isShow) return null;

  return (
    <Account>
      {user ? (
        <>
          <AccountSidebarContainer />
          <AccountSlotsContainer />
        </>
      ) : (
        <Loader />
      )}
    </Account>
  );
}

export default AccountContainer;
